import { STORAGE_KEY, STORYGRAPH_PILL_STYLE, type TransferData } from '../../constants'
import { maybeDownloadCover } from '../../utils/download'
import { getUserOptions } from '../settings'
import { parseChilchilPage } from './parser'

const CHILCHIL_BUTTON_ID = 'chilchil-port-to-sg-btn'

function openStoryGraphSearch (data: TransferData): void {
  const query = data.isbn || data.title
  const url = `https://app.thestorygraph.com/browse?search_term=${encodeURIComponent(query)}`
  if (typeof GM_openInTab === 'function') {
    GM_openInTab(url, { active: true })
  } else {
    window.open(url, '_blank')
  }
}

function isChilchilBookPage (): boolean {
  return /^\/goodsDetail\/goods_id\/\d+\/?/.test(window.location.pathname)
}

function getButtonHost (): HTMLElement | null {
  return document.querySelector<HTMLElement>('.c-detail_title, h1.title, h1')
}

export function injectChilchilPortButton (): void {
  if (!isChilchilBookPage()) return

  const host = getButtonHost()
  if (!host) return

  const existing = document.getElementById(CHILCHIL_BUTTON_ID) as HTMLAnchorElement | null
  if (existing) {
    if (existing.parentElement !== host) host.appendChild(existing)
    return
  }

  const btn = document.createElement('a')
  btn.id = CHILCHIL_BUTTON_ID
  btn.href = '#'
  btn.textContent = 'Port to StoryGraph'
  btn.style.cssText = `${STORYGRAPH_PILL_STYLE} margin:6px 0 0;`
  host.appendChild(btn)

  btn.addEventListener('click', (event) => {
    event.preventDefault()
    const data = parseChilchilPage()
    const options = getUserOptions()

    if (options.downloadChilchilCover) {
      maybeDownloadCover(data.title, data.coverUrl)
    }

    GM_setValue(STORAGE_KEY, JSON.stringify(data))
    openStoryGraphSearch(data)
  })
}
